import { SoknadSteg } from '../../components/registering/utils/registerEnums';
import { Soknad } from '../../types/building';
import { SoknadStegMap } from '../../types/soknad';
import { RegistrationCommonStep, RegistrationStep } from '../../utils/navigation';

// Step 2 and 3 uses initial state of their previous step if not yet created
export const getRegId = (soknadSteg?: SoknadSteg, soknad?: Soknad) => {
  switch (soknadSteg) {
    case SoknadSteg.Steg1:
      return soknad?.registreringForSteg1;
    case SoknadSteg.Steg2:
      // Handles case of new soknad step, returns previous step registration for initial state
      return soknad?.registreringForSteg2 ?? soknad?.registreringForSteg1;
    case SoknadSteg.Steg3:
      // Handles case of new soknad step, returns previous step registration for initial state
      return soknad?.registreringForSteg3 ?? soknad?.registreringForSteg2;
    default:
      return undefined;
  }
};

export const getRegistrationId = (soknadSteg: SoknadSteg, soknad?: Soknad) => {
  switch (soknadSteg) {
    case SoknadSteg.Steg1:
      return soknad?.registreringForSteg1;
    case SoknadSteg.Steg2:
      return soknad?.registreringForSteg2;
    case SoknadSteg.Steg3:
      return soknad?.registreringForSteg3;
    default:
      return undefined;
  }
};

export const isValidSoknad = (steg?: SoknadSteg, soknad?: Soknad, soknadId?: string) => {
  if (soknad?.soknadId != soknadId) {
    return false;
  }
  if (steg === SoknadSteg.Steg2 && !soknad?.registreringForSteg1) {
    return false;
  }
  return !(steg === SoknadSteg.Steg3 && !(soknad?.registreringForSteg1 && soknad?.registreringForSteg2));
};

export const isPublished = (soknadSteg?: SoknadSteg, soknadStegMap?: SoknadStegMap, step?: RegistrationStep) => {
  if (!soknadSteg) {
    return false;
  }

  const isSoknadSteg2 = soknadSteg === SoknadSteg.Steg2;
  const soknadStep2Done = soknadStegMap?.steg2?.done;

  const isPublished = !!soknadStegMap && soknadStegMap[soknadSteg]?.analysis?.registrering.publisertDato;

  if (isPublished) {
    return true;
  }

  const displayPublished = step !== RegistrationCommonStep.ENERGY_CERTIFICATE && isSoknadSteg2 && soknadStep2Done;

  return displayPublished;
};
